export default __webpack_public_path__ + "static/media/tl-stake.f4d02bc0.png";